module.exports = __webpack_public_path__ + "static/media/bologneseragusauce.5b2fcc55.jpg";